module.exports = __webpack_public_path__ + "static/media/kim_nkoubou_portrait.8118ab16.jpg";